<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/products/hardware" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back to Hardware
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">Digital <span class="text-varroc-accent">Cluster</span> Retrofit Display</h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">Upgrade any vehicle with a 10.25" Android Automotive digital instrument cluster — ConnectIQ-native, app-ready, and OTA-updatable with full CAN bus integration.</p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/store/product" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all digital_cluster_retrofit_display_buy_now_button">Buy Now</a>
          <a routerLink="/contact-us" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all digital_cluster_retrofit_display_oem_enquiry_button">OEM Enquiry</a>
        </div>
      </div>
    </div>
  </section>
  <nav class="sticky-product-nav"><div class="max-w-7xl mx-auto px-6"><div class="flex overflow-x-auto">
    <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0"><i class='bx text-base' [class]="s.icon"></i> {{ s.label }}</a>
  </div></div></nav>
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Modern Cluster for Any Vehicle</h2>
        <p class="text-varroc-text-gray text-lg max-w-2xl mx-auto">Replace your analogue gauges with a fully connected digital display that shows navigation, driving scores, app widgets, and live vehicle data.</p>
      </div>
    </section>
    <div class="accent-divider"></div>
    <section id="specs" class="section-anchor">
      <div class="text-center mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Specifications</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Technical Specs</h2>
      </div>
      <div class="grid md:grid-cols-3 gap-5">
        <div *ngFor="let s of specs; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="text-varroc-text-gray text-xs uppercase tracking-widest mb-1">{{ s.label }}</div>
          <div class="text-white font-bold">{{ s.value }}</div>
        </div>
      </div>
    </section>
    <!-- <div class="accent-divider"></div>
    <section id="buy" class="section-anchor">
      <div class="feature-card p-10 text-center" data-aos="fade-up">
        <p class="text-varroc-text-gray text-lg mb-6">Upgrade your dashboard today.</p>
        <a routerLink="/store/product" class="inline-block bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all">Shop Now</a>
      </div>
    </section> -->
  </div>
</main>
